module.exports = __webpack_public_path__ + "img/gh-202-flpart3.prt.ce6ceeb1.jpg";